import { render, staticRenderFns } from "./RealNamePopup.vue?vue&type=template&id=dd3b5f7e&scoped=true&"
import script from "./RealNamePopup.vue?vue&type=script&lang=js&"
export * from "./RealNamePopup.vue?vue&type=script&lang=js&"
import style0 from "./RealNamePopup.vue?vue&type=style&index=0&id=dd3b5f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3b5f7e",
  null
  
)

export default component.exports